"use strict";
exports.__esModule = true;
exports.LEGAL_ENTITY = void 0;
var LEGAL_ENTITY = {
    TYPE: {
        COMPANY: 'company',
        INDIVIDUAL: 'individual',
        TRUST: 'trust'
    }
};
exports.LEGAL_ENTITY = LEGAL_ENTITY;
